export enum RemissionOrderStateEnum {
    all = 1,
    pending = 2,
    evacuated = 3,
}